import * as React from 'react';
import { getPaletteAsRawColors } from 'owa-theme';
import { generateColorScheme } from 'owa-color-utils/lib/colorUtils';
import { getIsDarkTheme } from 'owa-fabric-theme';
import { AssetColors } from 'owa-timestream-asset-sdk-color/lib/colorMap';

export default function useCharmColorScheme(assetColor?: string) {
    const palette = getPaletteAsRawColors();
    const isDarkTheme = getIsDarkTheme();
    let grayColor = palette.neutralSecondary ?? '';
    if (!!assetColor) {
        if (isDarkTheme) {
            grayColor = palette.neutralQuaternary ?? '';
        }

        if (assetColor === AssetColors.Gray) {
            grayColor = isDarkTheme
                ? palette.neutralQuaternary ?? ''
                : palette.neutralSecondary ?? '';
        } else if (assetColor === AssetColors.Charcoal) {
            grayColor = isDarkTheme
                ? palette.neutralSecondary ?? ''
                : palette.neutralQuaternary ?? '';
        }
    }

    return React.useMemo(() => generateColorScheme(grayColor), [grayColor]);
}
